export const SET_AVATAR_IMAGE = 'SET_AVATAR_IMAGE'
export const SET_IMG_PATH = 'SET_IMG_PATH'
export const SET_IMG_STATUS = 'SET_IMG_STATUS'
export const SET_UNSAVED_DATA = 'SET_UNSAVED_DATA'
export const RESET_FORM = 'RESET_FORM'
